// const APP_URL = process.env.NODE_ENV === 'production' ? '/Griff/rest/' : 'http://localhost:8070/Griff/rest/';
//axios.defaults.headers.post['Content-Type'] = 'application/json';

// const Price = function (p) {
//     this.p = p;
// }
// Price.prototype.toString = function () {
//     return this.p?this.p.toLocaleString('hu-HU'):0
// }
// Price.prototype.valueOf = function () {
//     return this.p;
// }

var BASE = '/'

export default {
    methods: {
        connGetAPP_URL: function () {
            return process.env.NODE_ENV === 'production' ? BASE : 'http://localhost:8071/Panorama/';
            // return process.env.NODE_ENV === 'production' ? BASE : 'http://panorama.myitsolver.com/';

        },
        connBaseGET: function (url, success, error) {
            var self = this;
            axios.get(this.connGetAPP_URL() + url,{
                        headers: {
                            'X-SA-AUTH-TOKEN': this.$store.getters.getCurrentToken
                        }
                    }
                )
                .then(function (response) {
                    success({
                        data: self.formatPrice(response.data),
                        status: response.status
                    });
                })
                .catch(function (err_response) {
                    console.log(err_response);
                    if (error != null) {
                        if (err_response.response) {
                            console.log(err_response.response.data);
                            error({
                                data: err_response.response.data,
                                status: err_response.response.status
                            });
                        } else {
                            error({
                                data: err_response,
                                status: 999
                            })
                        }
                    }
                });
        },
        connBasePOST: function (url, body, success, error,h = {}) {
            h['Content-Type'] = 'application/json';
            h['X-SA-AUTH-TOKEN'] = this.$store.getters.getCurrentToken;

            axios.post(this.connGetAPP_URL() + url, body, {
                    headers: h
                }
            ).then(function (response) {
                    success({
                        data: response.data,
                        status: response.status
                    });
                })
                .catch(function (err_response) {
                    console.log(err_response);
                    if (error != null) {
                        if (err_response.response) {
                            error({
                                data: err_response.response.data,
                                status: err_response.response.status
                            });
                        } else {
                            error({
                                data: "Network error",
                                status: 999
                            })
                        }
                    }
                });
        },

        formatPrice(obj){
            //
            // if (obj.price){
            //     let p = obj.price
            //     obj.price = new Price(p)
            //     console.log(obj);
            // }
            // if (obj.originalPrice){
            //     let p = obj.originalPrice
            //     obj.originalPrice = new Price(p)
            //     console.log(obj);
            // }
            return obj;
        },

        //CUSOM ENDPOINTS

        connFilterProducts: function (search,success, error = null) {
            this.connBasePOST('data/filter',search, success, error);
        },
        connGetProductDetailed: function (id,success, error = null) {
            this.connBaseGET('data/product/{id}'.replace('{id}',id),success, error);
        },
        connGetPromotedProducts: function (id=null,success, error = null) {
            this.connBaseGET('data/product/promoted'+(id==null?'':'?categoryId='+id), success, error);
        },
        connGetDiscountProducts: function (success, error = null) {
            this.connBaseGET('data/product/discount', success, error);
        },
        connGetCategoryTree: function (success, error = null) {
            this.connBaseGET('data/category/tree', success, error);
        },
        connGetMenusTree: function (type,success, error = null) {
            this.connBaseGET('data/menu/{type}/tree'.replace('{type}',type), success, error);
        },

        //BASKET
        connBasketGet: function (success, error = null) {
            this.connBaseGET('basket',success, error);
        },
        connBasketAdd: function (obj,success, error = null) {
            this.connBasePOST('basket/add',obj, success, error);
        },
        connBasketChangeQuantity: function (itemId,quantity,success, error = null) {
            this.connBasePOST('basket/items/{itemId}/quantity/{q}'
                .replace('{itemId}',itemId).replace('{q}',quantity),null, success, error);
        },
        connBasketClear: function (success, error = null) {
            this.connBasePOST('basket/clear',null, success, error);
        },
        connBasketRemoveElement: function (id,success, error = null) {
            this.connBasePOST('basket/remove/{id}'.replace('{id}',id),null, success, error);
        },

        //WISHLIST
        connWishlistGet: function (success, error = null) {
            this.connBaseGET('wishlist',success, error);
        },
        connWishlistAdd: function (temp,obj,success, error = null) {
            this.connBasePOST('wishlist/add'+(temp?'/temp':''),obj, success, error);
        },
        connWishlistClear: function (success, error = null) {
            this.connBasePOST('wishlist/clear',null, success, error);
        },
        connWishlistRemoveElement: function (id,success, error = null) {
            this.connBasePOST('wishlist/remove/{id}'.replace('{id}',id),null, success, error);
        },
        connWishlistAddBasket: function (itemId,quantity,success, error = null) {
            this.connBasePOST('wishlist/basket/{itemId}?quantity={q}'
                .replace('{itemId}',itemId).replace('{q}',quantity || 0),null, success, error);
        },

        //WATCHED
        connWatchedGet: function (success, error = null) {
            this.connBaseGET('webshop/watched',success, error);
        },
        connWatchedAdd: function (id,success, error = null) {
            this.connBasePOST('webshop/watched/add/{id}'.replace('{id}',id),null, success, error);
        },
        connWatchedRemove: function (id,success, error = null) {
            this.connBasePOST('webshop/watched/remove/{id}'.replace('{id}',id),null, success, error);
        },

        //USER ACTIONS
        connLogout:function (success, error = null) {
            this.connBasePOST('logout',null,success,error);
        },
        connLogin:function (header,success, error = null) {
            this.connBasePOST('public/user/login',null,success,error,header);
        },
        connLoginFacebook:function (token,success, error = null) {
            this.connBasePOST('public/user/login/facebook/{token}'.replace('{token}',token),null,success,error);
        },
        connRegister:function (header,obj,success, error = null) {
            this.connBasePOST('public/user/register',obj,success,error,header);
        },
        connForgotPass:function (email,success, error = null) {
            this.connBaseGET('public/user/forgottenPassword/{email}'.replace('{email}',email),success,error);
        },
        connForgotPassValidation:function (token,success, error = null) {
            this.connBaseGET('public/user/forgottenPassword/check/{token}'.replace('{token}',token),success,error);
        },
        connProfileUpdate:function (header,obj,success, error = null) {
            this.connBasePOST('profile/update',obj,success,error,header);
        },
        connProfileGet:function (success, error = null) {
            this.connBaseGET('profile',success,error);
        },
        connDataUpdate:function (obj,success, error = null) {
            this.connBasePOST('profile/data',obj,success,error);
        },
        connDataGet:function (success, error = null) {
            this.connBaseGET('profile/data',success,error);
        },
        connMergeUsers:function (tempUserId, onlyWatched = false,success, error = null) {
            this.connBasePOST('webshop/merge/{tempUserId}?onlyWatched={ow}'
            .replace('{tempUserId}',tempUserId)
            .replace('{ow}',onlyWatched),null,success,error);
        },

        //CHECKOUT
        connCheckTempEmail:function (email,success, error = null) {
            this.connBaseGET('webshop/{email}/check'.replace('{email}',email),success,error);
        },
        connShopsGet:function (success, error = null) {
            this.connBaseGET('data/shops',success,error);
        },
        connOrderPlace:function (obj,tempUserId = null,email = null,success, error = null) {
            this.connBasePOST('webshop/order/make?tempUserId={tui}&email={email}'
            .replace('{tui}',tempUserId==null?'':tempUserId)
            .replace('{email}',email == null?'':email),obj,success,error);
        },
        connOrdersGet:function (success, error = null) {
            this.connBaseGET('webshop/order/my',success,error);
        },
        connCancelOrder:function (id,success, error = null) {
            this.connBasePOST('webshop/order/{id}/cancel'.replace('{id}',id),null,success,error);
        },
        connNewOrderPayment:function (id,success, error = null) {
            this.connBasePOST('webshop/order/{id}/new'.replace('{id}',id),null,success,error);
        },
        connCheckPayment:function (paymentId,success, error = null) {
            this.connBaseGET('webshop/order/{pid}/status'.replace('{pid}',paymentId),success,error);
        },

        //DATA: pages
        connGetPageDetailed: function (id, success, error = null) {
            this.connBaseGET('data/website/page/{id}'.replace('{id}',id), success, error);
        },
        connGetPageByType: function (type,success, error = null) {
            this.connBaseGET('data/website/page/type/{type}'.replace('{type}',type), success, error);
        },

        connSendBoraEmail:function (name,email,message,success, error = null) {
            this.connBasePOST('email/send',{name,email,message},success,error);
        },
        connSendPanoramaForm:function (object,type,success, error = null) {
            this.connBasePOST('email/panorama/send?type='+!!type,object,success,error);
        },
        connSubscribeToNewsletter:function (email,name,success, error = null) {
            this.connBasePOST('data/website/newsletter/subscribe',{email,name},success,error);
        },


    }

}



// WEBPACK FOOTER //
// ./src/app/commons/communication/endpoints.js